import moment from "moment";
import React, { useRef } from "react";
import { getInitials } from "../../utility/CommonFunctions";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";

export default function DashboardEventCard({
  title,
  workList = [],
  birthdayList = [],
}) {
  // console.log("birthdayList", birthdayList);
  // console.log("workList", workList);
  const navigate = useNavigate();
  const currentDate = new Date();
  const listRef = useRef(null);

  const isToday = (dateString) => {
    const date = new Date(dateString);
    return (
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth()
    );
  };

  const isUpcoming = (dateString) => {
    const date = new Date(dateString);
    return (
      date.getDate() > currentDate.getDate() ||
      date.getMonth() > currentDate.getMonth()
    );
  };

  // Determine which list to use based on the title
  const listKey = title === "Work Anniversary" ? "joiningDate" : "dob";
  const list = title === "Work Anniversary" ? workList : birthdayList;

  const todayItems = list?.filter((item) => isToday(item[listKey])) || [];
  const upcomingItems = list?.filter((item) => isUpcoming(item[listKey])) || [];

  return (
    <div className="col-12">
      <div className="card dash-card2 mb-0">
        <div className="card-body">
          <div className="card-head d-flex justify-content-between align-items-center">
            <h3 className="card-title">
              {title === "Birthday" ? title + "🎂" : title + "🏢"}
            </h3>
            <span
              className="text-primary fs-5 fw-bold"
              role="button"
              onClick={() => {
                // scroll only the list container to top
                if (listRef.current) {
                  listRef.current.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              Today
            </span>
          </div>

          {/* scrollable list */}
          <ul className="list-unstyled card-scrollable" ref={listRef}>
            {todayItems.length > 0 ? (
              todayItems.map((item) => (
                <li key={item.id}>
                    <div
                      className="user d-flex gap-3 mb-2 align-items-center"
                      role="button"
                      onClick={() => {
                        navigate(`${RoutesLink?.employee_detail}/${item?.id}`);
                      }}
                    >
                      <span className="user-icon">{getInitials(item.name)}</span>
                      <span className="fw-medium text-dark m-0">{item.name}</span>
                    </div>
                  </li>
                ))
              ) : (
              <li className="col-12">
                <span>
                  {title === "Work Anniversary"
                    ? "No work anniversaries today."
                    : "No birthdays today."}
                </span>
              </li>
            )}

            <hr />
            <span className="text-black fw-medium fs-5">Upcoming</span>

            {upcomingItems.length > 0 ? (
              upcomingItems.map((item) => (
                <li key={item.id}>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div
                      className="user d-flex gap-3 mb-2 align-items-center"
                      role="button"
                      onClick={() => {
                        navigate(`${RoutesLink?.employee_detail}/${item?.id}`);
                      }}
                    >
                      <span className="user-icon">
                        {getInitials(item.name)}
                      </span>
                      <span className="fw-medium text-dark m-0">{item.name}</span>
                    </div>
                    <span className="fs-6">
                      {moment(item[listKey]).format("DD-MM")}-
                      {new Date().getFullYear()}
                    </span>
                  </div>
                </li>
              ))
            ) : (
              <li className="col-12">
                <span>
                  {title === "Work Anniversary"
                    ? "No upcoming work anniversaries."
                    : "No upcoming birthdays."}
                </span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
